<div bsModal #ExportModal="bs-modal" class="modal fade" tabindex="-1" [config]="{backdrop: 'static', keyboard: false}" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{'Export.Title' | translate}}</h4>
        <button type="button" class="close  btn_closejobmodel" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="excel-export-modal">
        <app-jt-modal-page>
          <app-jt-modal-hor-form>
            <form-body>
              <div class="modal-body">
                <ng-container *ngIf="inputParams && inputParams.totalRows>0">
                  <form>
                    <div class="custom-control custom-radio custom-control-inline">
                      <h4>
                        <input type="radio" (change)="changeExportType(1)" id="radioCurrentPage" [checked]="exportType===1" name="customRadioInline1" class="custom-control-input">
                        <label class="custom-control-label" for="radioCurrentPage">{{'Export.CurrentPageOnly' | translate}}</label>
                      </h4>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <h4>

                        <input (change)="changeExportType(2)" type="radio" id="radioAll" name="customRadioInline1" [checked]="exportType===2" class="custom-control-input">
                        <label class="custom-control-label" for="radioAll">{{'Export.All' | translate}}</label>
                      </h4>
                    </div>
                  </form>
                  <div *ngIf="exportType===2">
                    <h3>{{'Export.Discription' | translate}}</h3>
                    <p *ngIf="inputParams"><b>{{'Export.TotalRecords' | translate}}{{inputParams.totalRows}}</b></p>
                    <p><b>{{'Export.Processed' | translate}} {{totalProcessed}} {{'Export.Of' | translate}} {{pageCount}}</b></p>
                    <p *ngIf="inputParams && inputParams.totalRows > allowdRecords" class="export-records-warning"><b>*{{'Export.OnlyAllowedRecord' | translate}}</b></p>
                  </div>
                </ng-container>
                <ng-container *ngIf="inputParams && inputParams.totalRows===0">
                  <h3>{{'Messages.Therearenocandidatesthatmatchyourcriteria' | translate}}.</h3>
                </ng-container>
              </div>
            </form-body>
            <div class="form-group row">
              <div class="col-md-12">
                <div class="action modal-footer">
                  <button type="button" class="btn btn-danger" (click)="closeModal()">{{'Export.Close' | translate}}</button>
                  <button type="button" *ngIf="inputParams && inputParams.totalRows>0" class="btn btn-primary" (click)="startExport()">{{'Export.StartExport' | translate}}</button>
                </div>
              </div>
            </div>
          </app-jt-modal-hor-form>
        </app-jt-modal-page>

      </div>
    </div>
  </div>
</div>
